import React from 'react';

export const MenuItem = (item, child, setActiveReportKey, onClick) => {
    return {
        icon: child.icon && <i className={`${child.icon}`} />,
        label: (
            <div className="menu-item-container">
                <span>{child.title}</span>
            </div>
        ),
        key: child.key ? child.key : child.title,
        onClick: () => {
            if(child.key && setActiveReportKey) {
                setActiveReportKey(child.key);
            }
            onClick(child.url);
        },
    };
};